export default __webpack_public_path__ + "static/media/avatar6-mujer.3dc70b9a.png";